export default function Services() {
  const services = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Consulta ginecológica general',
      description: 'Evaluación completa de tu salud reproductiva y prevención de enfermedades.',
      color: 'from-pink-400 to-pink-500'
    },
    {
      icon: 'ri-parent-line',
      title: 'Control prenatal y embarazo',
      description: 'Seguimiento integral durante tu embarazo para garantizar tu salud y la de tu bebé.',
      color: 'from-blue-400 to-blue-500'
    },
    {
      icon: 'ri-microscope-line',
      title: 'Papanicolaou y colposcopia',
      description: 'Detección temprana de alteraciones cervicales para tu tranquilidad y prevención.',
      color: 'from-pink-400 to-pink-500'
    },
    {
      icon: 'ri-scan-line',
      title: 'Ultrasonido pélvico y obstétrico',
      description: 'Estudios de imagen de alta precisión para diagnóstico y seguimiento.',
      color: 'from-blue-400 to-blue-500'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Planificación familiar',
      description: 'Asesoría personalizada sobre métodos anticonceptivos según tus necesidades.',
      color: 'from-pink-400 to-pink-500'
    },
    {
      icon: 'ri-medicine-bottle-line',
      title: 'Diagnóstico y tratamiento de infecciones',
      description: 'Atención especializada para infecciones ginecológicas con tratamiento efectivo.',
      color: 'from-blue-400 to-blue-500'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Procedimientos y servicios
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Atención integral para todas las etapas de tu vida
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-pink-400 to-blue-400 mx-auto mt-6 rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-pink-200 cursor-pointer"
            >
              <div className={`w-16 h-16 flex items-center justify-center rounded-2xl bg-gradient-to-br ${service.color} mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
